module.exports = __webpack_public_path__ + "static/media/copiii-sa-evite-locurile-de-joaca.f34499c1.jpeg";